/**
 * jQuery validationのメッセージ管理を行う.
 *
 * @author Nakagawa_Michio@ogis-ri.co.jp
 *
 */
switch ($('html').attr('lang')) {
  case 'ja':
    $.extend($.validator.messages, {
      required: 'このフィールドは必須です。',
      remote: 'このフィールドを修正してください。',
      email: '有効なEメールアドレスを入力してください。',
      url: '有効なURLを入力してください。',
      date: '有効な日付を入力してください。',
      dateISO: '有効な日付（ISO）を入力してください。',
      number: '有効な数字を入力してください。',
      digits: '数字のみを入力してください。',
      creditcard: '有効なクレジットカード番号を入力してください。',
      equalTo: '同じ値をもう一度入力してください。',
      extension: '有効な拡張子を含む値を入力してください。',
      maxlength: $.validator.format('{0} 文字以内で入力してください。'),
      minlength: $.validator.format('{0} 文字以上で入力してください。'),
      rangelength: $.validator.format('{0} 文字から {1} 文字までの値を入力してください。'),
      range: $.validator.format('{0} から {1} までの値を入力してください。'),
      step: $.validator.format('{0} の倍数を入力してください。'),
      max: $.validator.format('{0} 以下の値を入力してください。'),
      min: $.validator.format('{0} 以上の値を入力してください。'),
      // CUSTOM MESSAGES
      notBlank: '空白は許可されていません。',
      address_maxrecord: $.validator.format('登録可能なアドレスは{0}件までです。'),
      address_unique: '同一のアドレスが存在します。',
      loginId_pattern: '半角英数字および記号で入力してください。',
      password_pattern: '半角英数字および記号で入力してください。',
      newPassword_notEqualTo: '現在のパスワードと同じ値は使用出来ません。',
      newPassword_pattern: '半角英数字および記号で入力してください。',
      invalid_domain: '許可されていないドメインです。',
      informationTitle_correlationRequired: 'タイトルを入力して下さい。',
      roles_group: '最低1つのチェックが必要です。',
      password_lessThanEqual: 'パスワード最大文字数以下にしてください。',
      enables_group: '最低1つのチェックが必要です。',
      approvalState_require_from_group: '承認状況から一つは選択する必要があります。',
      requires_checkBoxEqualTo: '必須文字が入力可能文字に含まれていません。',
      expiredStorageDay_lessThanEqual: 'アーカイブ保存期間の上限値は履歴データ保存期間以下にしてください。',
      enabledSMS_withLegacyMode_cannotBeEnabled:
        'レガシーモードが有効な場合、SMSによるパスワード通知は利用できません。',
      domainName_maxrecord: $.validator.format('登録可能なドメインは{0}件までです。'),
      domainName_unique: '既に同一のドメインが存在します。',
      domainName_pattern: '有効な値ではありません。',
      ipAddress_maxrecord: $.validator.format('登録可能なIPアドレスは{0}件までです。'),
      ipAddress_unique: '既に同一のIPアドレスが存在します。',
      ipAddress_ipAddress: '有効な値ではありません。',
      allows_require_from_group: '最低1つのチェックが必要です。',
      creditCardHolderName_pattern: '半角英数字、半角スペースおよび記号(,.-/)で入力してください。',
      creditCardExpMonth_pattern: '月(2桁)の値が不正です',
      same_file_name: '同名ファイルが選択されています。',
      max_file_numbers: '最大送信可能ファイル数を超えています。',
      max_file_size: '最大送信可能ファイルサイズを超えています。',
      file_name_invalid:
        "ファイル名に使用できない文字が含まれています。(% .. { } ~ / : * ? \\ “ < > | ' ` またはピリオドから始まるファイル名)",
      file_name_length_invalid: 'ファイル名の長さは全角25文字程度にして下さい。',
      file_empty: '空のファイルは送信できません。',
      phone_number_invalid: '携帯電話番号をハイフン無し数字11桁で入力してください。',
    })
    break
  case 'zh':
    $.extend($.validator.messages, {
      required: '这是必填字段',
      remote: '请修正此字段',
      email: '请输入有效的电子邮件地址',
      url: '请输入有效的网址',
      date: '请输入有效的日期',
      dateISO: '请输入有效的日期 (YYYY-MM-DD)',
      number: '请输入有效的数字',
      digits: '只能输入数字',
      creditcard: '请输入有效的信用卡号码',
      equalTo: '你的输入不相同',
      extension: '请输入有效的后缀',
      maxlength: $.validator.format('最多可以输入 {0} 个字符'),
      minlength: $.validator.format('最少要输入 {0} 个字符'),
      rangelength: $.validator.format('请输入长度在 {0} 到 {1} 之间的字符串'),
      range: $.validator.format('请输入范围在 {0} 到 {1} 之间的数值'),
      step: $.validator.format('请输入 {0} 的整数倍值'),
      max: $.validator.format('请输入不大于 {0} 的数值'),
      min: $.validator.format('请输入不小于 {0} 的数值'),
      // CUSTOM MESSAGES
      notBlank: '不允许使用空格。',
      address_maxrecord: $.validator.format('最多可以注册{0}个地址。'),
      address_unique: '存在相同的地址。',
      loginId_pattern: '请用半角字母数字和符号输入。',
      password_pattern: '请用半角字母数字和符号输入。',
      newPassword_notEqualTo: '不能使用与当前密码相同的值。',
      newPassword_pattern: '请用半角字母数字和符号输入。',
      invalid_domain: '不允许的域。',
      informationTitle_correlationRequired: '请输入标题。',
      roles_group: '至少需要1个复选标记。',
      password_lessThanEqual: '密码长度不能超过最大字符数。',
      enables_group: '至少需要1个复选标记。',
      approvalState_require_from_group: '必须从批准状态中选择一个。',
      requires_checkBoxEqualTo: '所需字符不包含在可输入字符中。',
      expiredStorageDay_lessThanEqual: '最大存档保留期应小于或等于历史数据保留期。',
      enabledSMS_withLegacyMode_cannotBeEnabled: '如果启用了传统模式，就不能用短信通知密码。',
      domainName_maxrecord: $.validator.format('最多可以注册{0}个域。'),
      domainName_unique: '已存在相同的域。',
      domainName_pattern: '值无效。',
      ipAddress_maxrecord: $.validator.format('最多可以注册{0}个IP地址。'),
      ipAddress_unique: '已存在相同的IP地址。',
      ipAddress_ipAddress: '值无效。',
      allows_require_from_group: '至少需要1个复选标记。',
      creditCardHolderName_pattern: '请输入半角字母数字、半角空格和符号(,.-/)。',
      creditCardExpMonth_pattern: '月份（两位数）值无效',
      same_file_name: '已选择同名文件。',
      max_file_numbers: '超出了可发送的最大文件数。',
      max_file_size: '超出最大可发送文件大小。',
      file_name_invalid: "文件名包含无法使用的字符。(% .. { } ~ / : * ? \\ “ < > | ' ` 或以句点开头的文件名)",
      file_name_length_invalid: '文件名的长度应为25个全角字符。',
      file_empty: '空文件无法发送。',
      phone_number_invalid: '使用不带连字符的 11 位数字输入手机号码。',
    })
    break
  default:
    $.extend($.validator.messages, {
      required: 'This field is required.',
      remote: 'Please fix this field.',
      email: 'Please enter a valid e-mail address.',
      url: 'Please enter a valid URL.',
      date: 'Please enter a valid date.',
      dateISO: 'Please enter a valid date (ISO).',
      number: 'Please enter a valid number.',
      digits: 'Please enter only digits.',
      creditcard: 'Please enter a valid credit card number.',
      equalTo: 'Please enter the same value again.',
      extension: 'Please enter a value contains valid extension.',
      maxlength: $.validator.format('Please enter no more than {0} characters.'),
      minlength: $.validator.format('Please enter at least {0} characters.'),
      rangelength: $.validator.format('Please enter a value between {0} and {1} characters long.'),
      range: $.validator.format('Please enter a value between {0} and {1}.'),
      max: $.validator.format('Please enter a value less than or equal to {0}.'),
      min: $.validator.format('Please enter a value greater than or equal to {0}.'),
      step: $.validator.format('Please enter a multiple of {0}.'),
      // CUSTOM MESSAGES
      notBlank: 'No whitespace is allowed',
      address_maxrecord: $.validator.format('Up to {0} addresses can be registered.'),
      address_unique: 'The same address exists',
      loginId_pattern: 'Enter in single-byte alphanumeric characters and symbols.',
      password_pattern: 'Enter in single-byte alphanumeric characters and symbols.',
      newPassword_notEqualTo: 'The same password as the current password cannot be used.',
      newPassword_pattern: 'Enter in single-byte alphanumeric characters and symbols.',
      invalid_domain: 'The domain is not allowed.',
      informationTitle_correlationRequired: 'Please enter a title.',
      roles_group: 'Requires at least one checking.',
      password_lessThanEqual: 'Password must be less than or equal to the maximum number of characters.',
      enables_group: 'Requires at least one checking.',
      approvalState_require_from_group: 'One of the approval statuses must be selected.',
      requires_checkBoxEqualTo: 'Required characters are not included in the inputtable characters.',
      expiredStorageDay_lessThanEqual:
        'The maximum archive retention period must be less than or equal to the historical data retention period.',
      enabledSMS_withLegacyMode_cannotBeEnabled:
        'If legacy mode is enabled, password notification by SMS is not available.',
      domainName_maxrecord: $.validator.format('Only {0} domains can be registered.'),
      domainName_unique: 'The same domain already exists.',
      domainName_pattern: 'Not a valid value.',
      ipAddress_maxrecord: $.validator.format('Up to {0} IP addresses can be registered.'),
      ipAddress_unique: 'The same IP address exists.',
      ipAddress_ipAddress: 'Not a valid value.',
      allows_require_from_group: 'Requires at least one checking.',
      creditCardHolderName_pattern: 'Enter single-byte alphanumeric characters, single-byte spaces, and symbols(,.-/).',
      creditCardExpMonth_pattern: 'The month (2-digit) is invalid',
      same_file_name: 'The file with the same name is selected.',
      max_file_numbers: 'The maximum number of files that can be sent has been exceeded.',
      max_file_size: 'The maximum file size that can be transmitted has been exceeded.',
      file_name_invalid:
        "The file name contains characters that cannot be used.(% .. { } ~ / : * ? \\ “ < > | ' ` or a file name that starts with a period)",
      file_name_length_invalid: 'The length of the file name should be about 25 full-pitch characters.',
      file_empty: 'Empty files cannot be sent.',
      phone_number_invalid: 'Enter the mobile phone number using 11 digits without hyphens.',
    })
}
